import React, { useEffect } from 'react'

type EventName = 'keyup' | 'keydown' | 'keypress'

export function useKey<T extends HTMLElement>(
  ref: React.RefObject<T>,
  event: EventName,
  handler: (key: string, e: KeyboardEvent) => void,
  key?: string,
) {
  useEffect(() => {
    const node = ref.current
    const handleKeyUp = (e: KeyboardEvent) => {
      if (e.target === node) {
        if (key && e.key === key) {
          handler(e.key, e)
        } else if (!key) {
          handler(e.key, e)
        }
      }
    }
    if (node) {
      document.addEventListener(event, handleKeyUp)
    }
    return () => {
      if (node) {
        document.removeEventListener(event, handleKeyUp)
      }
    }
  }, [ref, handler, event, key])

  return ref
}
